import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import styled from "styled-components";
import { CLOUDN_COLORS } from "../../../constants/colors";
import PublicStyledTableCell from "../../publics/PublicStyledTableCell";
import { EplusTableProps } from "../../../constants/types";
import { useEffect, useState } from "react";
import EplusTableRow from "../../atoms/\bshowcase/EplusTableRow";

const EplusTable = (props: EplusTableProps) => {
  const [rows, setRows] = useState<JSX.Element[]>([]);

  // useEffect(() => {
  //   setRows(
  //     props.data.map((data, index) => <EplusTableRow data={data} key={index} />)
  //   );
  // }, [props.data]);

  useEffect(() => {
    const list = props.data
      .slice(props.page.state * 30, props.page.state * 30 + 30)
      .map((data, index) => <EplusTableRow data={data} key={index} />);
    setRows(list);
  }, [props.data, props.page.state]);
  return (
    <Container>
      <TableContainer
        sx={{
          width: "100%",
          height: "100%",
          borderBottom: `0.2vw solid ${CLOUDN_COLORS.logoSkyBlue}`,
        }}
      >
        <Table style={{ width: "100%", borderSpacing: 0 }} stickyHeader>
          <TableHead>
            <TableRow>
              <PublicStyledTableCell>번호</PublicStyledTableCell>
              <PublicStyledTableCell>프로젝트명</PublicStyledTableCell>
              <PublicStyledTableCell>기기명(판넬명)</PublicStyledTableCell>
              <PublicStyledTableCell>ID</PublicStyledTableCell>
              <PublicStyledTableCell>현재 온도(°C)</PublicStyledTableCell>
              <PublicStyledTableCell>기준 온도(°C)</PublicStyledTableCell>
              <PublicStyledTableCell>비고</PublicStyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>{rows}</TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default EplusTable;

const Container = styled.div`
  width: 100%;
  height: 87%;
`;
